import { toRem, toRems } from 'helpers/theme'

/* eslint-disable quote-props */
const style = ({ theme }) => ({
    margin: toRem(20),
    '& .BuildContainer': {
        background: theme.colors.blueLight,
        maxWidth: 1440,
        margin: 'auto',
        padding: toRem(20),
        borderRadius: 4,
        [theme.breakpoints.up('md')]: {
            padding: toRem(80)
        },
        '& .Title': {
            color: theme.colors.goldDark,
            fontSize: toRem(20),
            [theme.breakpoints.up('lg')]: {
                fontSize: toRem(24),
                fontWeight: '500'
            }
        },
        '& .BlockCaption': {
            display: 'block',
            marginBottom: toRem(40),
            [theme.breakpoints.up('md')]: {
                display: 'flex',
                marginBottom: toRem(35)
            },
            '& .Subtitle': {
                flex: 1,
                marginBottom: toRem(45),
                fontSize: toRem(14),

                [theme.breakpoints.up('lg')]: {
                    marginBottom: 0,
                    fontSize: toRem(20)
                }
            },
            '& .Text': {
                flex: 1,
                fontSize: toRem(14),

                [theme.breakpoints.up('lg')]: {
                    fontSize: toRem(20)
                }
            }
        },
        '& .CtaContainer': {
            textAlign: 'center',
            padding: '18px 0 20px',
            [theme.breakpoints.up('lg')]: {
                padding: '50px 0 0'
            }
        }
    }
})

export default style
